module.exports = __webpack_public_path__ + "img/s6Model1.e582d74a.webp";